import React from 'react'
import Hero from '../elements/Hero'

const Home = () => {
  return (
    <>
    <Hero />
    </>
  )
}

export default Home